// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon_icon__2Xooe{flex-shrink:0}", ""]);
// Exports
exports.locals = {
	"icon": "icon_icon__2Xooe"
};
module.exports = exports;
